export const addFavorite = async (jobId: number) => {
  await fetch('/api/nextjs_api/favorites', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ jobId }),
  });
};

export const removeFavorite = async (jobId: number) => {
  await fetch('/api/nextjs_api/favorites', {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ jobId }),
  });
};
